module.exports = __webpack_public_path__ + "static/media/phone-pwa-mockup.5e413dbb.png";